module.exports = __webpack_public_path__ + "img/05.098c5c58.jpg";